import { Link } from "react-router-dom";
import { ArrowUpRight, Check, Radio, Sparkles } from "lucide-react";
import { MwHeader } from "@/components/mediaweb/MwHeader";
import { MwFooter } from "@/components/mediaweb/MwFooter";

const features = [
  "Votre logo HD et couleur de marque",
  "Métadonnées Now Playing en temps réel (Icecast / ICY / API)",
  "Pochettes d'album haute définition récupérées automatiquement",
  "Compatible CarPlay & Android Auto",
  "Lien direct vers votre site officiel depuis la carte",
  "Hébergement et bande passante inclus toute l'année",
];

export default function OfferStreamPage() {
  return (
    <div className="mw-app">
      <MwHeader />

      {/* ===== Hero ===== */}
      <section className="mw-section mw-section-hero-page">
        <div className="mw-section-head">
          <span className="mw-section-eyebrow">Offre Stream-only · WallTunes</span>
          <h1 className="mw-h1 mw-h1-small">
            Diffusez votre radio sur WallTunes
            <br />
            <span className="mw-h1-accent">— sans développer de PWA</span>
          </h1>
          <p className="mw-section-lead">
            Pour les radios indépendantes qui existent déjà et souhaitent
            simplement rejoindre notre mur WallTunes — sans construire de PWA
            dédiée. Logo, métadonnées, pochettes HD et compatibilité
            CarPlay/Android Auto inclus.
          </p>
        </div>

        {/* ===== Price card ===== */}
        <div className="mw-stream-pricecard">
          <div className="mw-stream-pricecard-tag">
            <Radio size={12} /> Stream-only · WallTunes
          </div>
          <div className="mw-stream-pricecard-price">
            50 €<span>/ an</span>
          </div>
          <p className="mw-stream-pricecard-desc">
            Un tarif annuel transparent, intégration en 48 h après réception de
            votre flux et de votre logo.
          </p>

          <ul className="mw-stream-pricecard-list">
            {features.map((f) => (
              <li key={f}>
                <Check size={14} strokeWidth={2.4} className="mw-pack-check" />
                <span>{f}</span>
              </li>
            ))}
          </ul>

          <Link
            to="/contact"
            className="mw-btn mw-btn-primary mw-stream-pricecard-cta"
            data-testid="stream-contact-cta"
          >
            Nous contacter <ArrowUpRight size={16} />
          </Link>
          <div className="mw-stream-pricecard-note">
            Cette offre rejoindra prochainement notre plateforme dédiée
            walltunes.com avec souscription en ligne. En attendant, contactez-nous
            directement — nous traitons votre demande sous 48 h.
          </div>
        </div>
      </section>

      {/* ===== Comment ça marche ===== */}
      <section className="mw-section">
        <div className="mw-section-head">
          <span className="mw-section-eyebrow">Comment ça marche ?</span>
          <h2 className="mw-h2">Une intégration en 3 étapes</h2>
        </div>

        <div className="mw-steps">
          <div className="mw-step">
            <div className="mw-step-num">01</div>
            <h3 className="mw-step-title">Vous nous envoyez votre flux</h3>
            <p className="mw-step-text">
              URL du stream, logo HD, couleur de marque, lien vers votre site.
              Via notre formulaire de contact ou par e-mail.
            </p>
          </div>
          <div className="mw-step">
            <div className="mw-step-num">02</div>
            <h3 className="mw-step-title">Validation & facturation</h3>
            <p className="mw-step-text">
              50 € pour 12 mois. Vous recevez une facture MediaWebRadio Ltd à
                régler par virement ou carte.
            </p>
          </div>
          <div className="mw-step">
            <div className="mw-step-num">03</div>
            <h3 className="mw-step-title">En ligne sous 48 h</h3>
            <p className="mw-step-text">
              On configure, on teste, on publie. Votre radio est accessible sur
              WallTunes (web, mobile, CarPlay, Android Auto).
            </p>
          </div>
        </div>
      </section>

      {/* ===== Alternative PWA ===== */}
      <section className="mw-section">
        <div className="mw-stream-card mw-stream-card-soft">
          <div className="mw-stream-card-inner">
            <div className="mw-stream-card-left">
              <span className="mw-pack-ribbon mw-stream-ribbon">
                <Sparkles size={12} /> Pour les marques & enseignes
              </span>
              <h3 className="mw-stream-title">
                Vous représentez une chaîne, un centre commercial ou une marque ?
              </h3>
              <p className="mw-stream-desc">
                Notre offre PWA professionnelle inclut bien plus : application
                installable dédiée, design sur mesure, lecteur audio natif,
                flyers et QR codes, jingles personnalisés. Présence WallTunes
                comprise pendant toute la durée du contrat.
              </p>
            </div>
            <div className="mw-stream-card-right">
              <Link to="/offre-pwa" className="mw-btn mw-btn-ghost">
                Découvrir nos forfaits PWA <ArrowUpRight size={14} />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <MwFooter />
    </div>
  );
}
